import { createContext, useContext } from 'react';

const mockUser = { id: 101, name: 'Иванов Иван' };

const UserContext = createContext(mockUser);

export const UserProvider = ({ children }) => (
  <UserContext.Provider value={mockUser}>
    {children}
  </UserContext.Provider>
);

export const useUser = () => useContext(UserContext);